import { c as _c } from "react/compiler-runtime";
import { graphql, readFragment } from "@opensea/graphql";
import { CardFooterBadge, classNames, NumberDisplay, TextLabel } from "@opensea/ui-kit";
import { Stat0Filled } from "@opensea/ui-kit/icons";
import { rarityVariants } from "@/components/rarity/constants";
import { RarityTooltip, RarityTooltipFragment } from "../rarity/RarityTooltip";
export const RarityBadgeFragment = graphql(`
    fragment RarityBadgeFragment on Item {
      rarity {
        rank
        category
      }
      ...RarityTooltip
    }
  `, [RarityTooltipFragment]);
export function RarityBadge(t0) {
  const $ = _c(18);
  const {
    item: itemKey
  } = t0;
  let T0;
  let T1;
  let item;
  let t1;
  let t2;
  let t3;
  if ($[0] !== itemKey) {
    t3 = Symbol.for("react.early_return_sentinel");
    bb0: {
      item = readFragment(RarityBadgeFragment, itemKey);
      if (!item?.rarity?.category) {
        t3 = null;
        break bb0;
      }
      T1 = RarityTooltip;
      t2 = item;
      T0 = CardFooterBadge;
      t1 = classNames("gap-0 pl-[0.5px]", rarityVariants({
        variant: item.rarity.category
      }).text());
    }
    $[0] = itemKey;
    $[1] = T0;
    $[2] = T1;
    $[3] = item;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    T0 = $[1];
    T1 = $[2];
    item = $[3];
    t1 = $[4];
    t2 = $[5];
    t3 = $[6];
  }
  if (t3 !== Symbol.for("react.early_return_sentinel")) {
    return t3;
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Stat0Filled size={18} />;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== item.rarity.rank) {
    t5 = <TextLabel><NumberDisplay display="full" prefix="#" value={item.rarity.rank} /></TextLabel>;
    $[8] = item.rarity.rank;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== T0 || $[11] !== t1 || $[12] !== t5) {
    t6 = <T0 className={t1}>{t4}{t5}</T0>;
    $[10] = T0;
    $[11] = t1;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== T1 || $[15] !== t2 || $[16] !== t6) {
    t7 = <T1 item={t2}>{t6}</T1>;
    $[14] = T1;
    $[15] = t2;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
}